/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Tool_Detail_PathInputs */

const es_chat_tool_detail_path = /** @type {(inputs: Chat_Tool_Detail_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ruta`)
};

const en_chat_tool_detail_path = /** @type {(inputs: Chat_Tool_Detail_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Path`)
};

/**
* | output |
* | --- |
* | "Path" |
*
* @param {Chat_Tool_Detail_PathInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const chat_tool_detail_path = /** @type {((inputs?: Chat_Tool_Detail_PathInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tool_Detail_PathInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_chat_tool_detail_path(inputs)
	return en_chat_tool_detail_path(inputs)
});
export { chat_tool_detail_path as "chat.tool_detail.path" }